{
  "people": "People",
  "loadingPeople": "Loading people…",
  "loadingTeams": "Loading teams…",
  "loadingReferrals": "Loading referrals…",
  "teams": "Teams",
  "filters": "Filters",
  "more": "More",
  "search": "Search people",
  "noManager": "No Manager",
  "moreRoles": "+{{count}} more",
  "allRoles": "All sales roles",
  "practiceLink": "Practice link",
  "closeNote": "Close details",
  "history": "Reporting history",
  "documentFollowUp": "Document follow-up",
  "viewProfile": "View profile",
  "removeFilter": "Remove filter: {{label}}"
}
